import "phaser";
import App from '../main';
import ControlPoint, { rotationDirections } from "../Sprites/ControlPoint";
import { Game, Direction } from "../app/game";
import { Math } from "phaser";
import MapGenerator from '../app/MapGenerator'

export class RoadPiece extends Phaser.GameObjects.Sprite {

  public collider: Phaser.Physics.Matter.Sprite;

  public nextRoad: RoadPiece;


  private game;

  public roadType: RoadType;

  mapGenerator: MapGenerator;

  private colliderType: any;
  public offSetDirectionX: number;
  public offSetDirectionY: number;
  colliders: any;

  roadIndex: number;


  controlPoint: ControlPoint;

  constructor(game: Phaser.Scene, roadType: RoadType, mapGenerator: MapGenerator,) {
    super(game, 0, 0, 'spritesAtlaas', 'straight.png');
    this.setScale(0.5)
    this.setTexture('spritesAtlaas', this.getSpriteKey(roadType));
    this.colliders = App.colliderData;
    this.game = game;
    this.mapGenerator = mapGenerator;

    switch (roadType) {
      case RoadType.straight: this.colliderType = this.colliders.straight; break;
      case RoadType.turn: this.colliderType = this.colliders.turn; break;
      case RoadType.uturn: this.colliderType = this.colliders.u_turn; break;
      case RoadType.loop: this.colliderType = this.colliders.loop; break;
    }

    this.collider = game.matter.add.sprite(0, 0, 'spritesAtlaas', 'empty.png', { shape: this.colliderType });
    //this.collider = game.matter.add.sprite(0, 0, 'spritesAtlaas', 'empty.png');
    // this.collider.setRectangle(5, 20, { isSensor: true }); 
    this.roadType = roadType;
    this.setDepth(2);
    this.collider.setStatic(true);
    this.collider.setSensor(true)
    this.game.matter.world.on('collisionstart', this.onCollisionStart.bind(this));
    this.game.events.on('update', (time, delta) => { this.update(time, delta) });
    this.SetVisibilityRoadAndCP(false)

    if (this.roadType != RoadType.straight) {
      this.controlPoint = new ControlPoint(this.game, this);
    }
    //this.game.events.on('restart', () => { this.Restart() });

  }

  InstantiateRoad(x: number, y: number) {
    this.SetVisibilityRoadAndCP(true)
    this.setPosition(x, y);
    this.collider.setPosition(x, y)
    this.setDepth(2);
  }


  onCollisionStart(event, bodyA, bodyB) {

    if ((bodyA.parent == this.collider.body && bodyB.parent == Game.car.carSprite.body) || (bodyA.parent == Game.car.carSprite.body && bodyB.parent == this.collider.body)) {

      this.game.OnCarCrash();
    }

  }

  update(time: number, delta: number) {
    if (this.active && this.roadIndex < Game.currentControlPoint.road.roadIndex - 10) {
      this.SetVisibilityRoadAndCP(false)
      this.mapGenerator.createRoadPiece();
    }
  }

  getSpriteKey(roadType: RoadType): string {
    let key: string;
    switch (roadType) {
      case RoadType.straight:
        key = "straight.png";
        break;
      case RoadType.turn:
        key = "turn.png";
        break;
      case RoadType.uturn:
        key = "uturn.png";
        break;
      case RoadType.loop:
        key = "loop.png";
        break;
    }
    return key;
  }

  setControlPoint(angle: number, rotationDirection: number, direction: Direction, cpNumber: number): ControlPoint {
    let x, y;
    //down - right
    if (angle == 90) {
      this.offSetDirectionX = 1;
      this.offSetDirectionY = -1;
    }
    //down - left
    if (angle == 0) {
      this.offSetDirectionX = -1;
      this.offSetDirectionY = -1;
    }
    // up right
    if (angle == 180) {
      this.offSetDirectionX = 1;
      this.offSetDirectionY = 1;
    }
    //up left
    if (angle == 270) {
      this.offSetDirectionX = -1;
      this.offSetDirectionY = 1;
    }
    //redundant declaration; this issue; resolve later
    x = this.offSetDirectionX;
    y = this.offSetDirectionY;
    let cpSpritePos = { x, y };
    switch (this.roadType) {
      case RoadType.uturn:
        switch (Game.currentGameDirection) {
          case Direction.left:
          case Direction.right:
            cpSpritePos.x = this.x;
            cpSpritePos.y = this.y + (y * (this.height / 4 - 5));
            break;

          case Direction.up:
          case Direction.down:
            cpSpritePos.x = this.x + (x * (this.height / 4 - 5));
            cpSpritePos.y = this.y;
            break;
        } break;
      case RoadType.turn:
        cpSpritePos.x = this.x + (x * (this.width / 4 - 45))
        cpSpritePos.y = this.y + (y * (this.height / 4 - 45))

        break;
      case RoadType.loop:
        cpSpritePos.x = this.x
        cpSpritePos.y = this.y
        break;

    }

    this.controlPoint.InstantiateControlPoint(
      this.x,
      this.y,
      rotationDirection,
      direction,
      cpSpritePos.x,
      cpSpritePos.y,
      this,
      cpNumber
    );


    let offsetX = this.width / 4 - this.collider.centerOfMass.x
    let offsetY = this.height / 4 - this.collider.centerOfMass.y

    //up or down switch x y 
    if (Game.currentGameDirection == 2 || Game.currentGameDirection == 3) {
      let temp = offsetX;
      offsetX = offsetY;
      offsetY = temp
    }
    this.collider.setPosition(this.collider.x + (x * offsetX), this.collider.y + (y * offsetY))
    return this.controlPoint;
  }


  SetVisibilityRoadAndCP(bool: boolean) {
    this.setActive(bool);
    this.setVisible(bool);

    let collisionLayer;

    if (bool) {
      collisionLayer = Game.enableCollisionLayer
    }
    else {
      collisionLayer = Game.disableCollisionLayer
    }
    if (this.controlPoint)
      this.controlPoint.EnableCP(bool);
    this.collider.setCollisionCategory(collisionLayer)

  }

  Restart() {
    this.SetVisibilityRoadAndCP(false);
  }

}

export enum RoadType {
  straight,
  turn,
  uturn,
  loop
}
